import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=611a570c"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports